export const APPLY_FILTERS = 'APPLY_FILTERS';
export const SET_CONTRACTS = 'SET_CONTRACTS';
export const SET_ACTIVE_CONTRACTS = 'SET_ACTIVE_CONTRACTS';
export const SET_CLOSE_CONTRACTS = 'SET_CLOSE_CONTRACTS';
export const SET_CLIENT_DETAIL = 'SET_CLIENT_DETAIL';
export const SET_CLIENT_NOTES = 'SET_CLIENT_NOTES';
export const SET_CLIENT_DOCS = 'SET_CLIENT_DOCS';
export const SET_CLIENT_DOC_TYPES = 'SET_CLIENT_DOC_TYPES';
export const SET_CLIENT_BANK_ACCOUNTS = 'SET_CLIENT_BANK_ACCOUNTS';
export const SET_CHECK_CONTRACT_COMPONENT = 'SET_CHECK_CONTRACT_COMPONENT';
export const RESET = 'RESET';
